module.exports = __webpack_public_path__ + "static/img/cont501.0460b24.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont501.jpg
// module id = gMmH
// module chunks = 0